import React, { Fragment } from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';

import { ExamCentersListItem } from './ExamCentersListItem';
import media from '../../../utils/mediaQueries';
import { ExamCentersSearch } from './ExamCentersSearch';
import { adShape } from '../propTypes';
import { ProductBlock } from './ProductBlock';

const ListContainer = styled.div`
  width: 50%;
  margin: 16px 0;
  
  ${media.mobile`
    width: 100%;
    padding: 0;
  `}
`;

const List = styled.ul`
  padding: 0 24px 0 0;
  margin: 16px 0 24px;
  list-style: none;
  
  ${media.mobile`
    padding: 0;
  `}
`;

const NoItemsPlaceholder = styled.div`
  width: 50%;
  margin: 24px;
  
  ${media.mobile`
    width: 100%;
  `}
`;

const ExamCentersList = ({
  examCentersData, mapObject, isMobile, ads,
}) => (
  <ListContainer>
    <ExamCentersSearch />
    {
          examCentersData.length
            ? (
              <List>
                {examCentersData.map((feature, index) => {
                  const ad = ads[index / 2];
                  return (
                    <Fragment key={`exam-center-search-item-${index}`}>
                      <ExamCentersListItem
                        key={feature.properties.id}
                        data={feature}
                        mapObject={mapObject}
                        isMobile={isMobile}
                      />
                      {(index % 2 === 0 && ad) // we show ads on 2, 5, 8,... positions
                        ? <ProductBlock key={`ad-${index}`} {...ad} /> : null}
                    </Fragment>
                  );
                })}
              </List>
            )
            : (
              <NoItemsPlaceholder>
                Il n&apos;y a pas de centres d&apos;examen au code de la route dans cette
                zone
              </NoItemsPlaceholder>
            )
        }
  </ListContainer>
);

ExamCentersList.propTypes = {
  examCentersData: PropTypes.arrayOf(PropTypes.shape({
    type: PropTypes.string,
    geometry: PropTypes.shape({
      type: PropTypes.string,
      coordinates: PropTypes.arrayOf(PropTypes.number),
    }),
    properties: PropTypes.object,
  })).isRequired,
  mapObject: PropTypes.object,
  isMobile: PropTypes.bool,
  ads: PropTypes.arrayOf(adShape),
};

ExamCentersList.defaultProps = {
  isMobile: false,
  mapObject: null,
  ads: [],
};

export { ExamCentersList };
